export default "__VITE_ASSET__BWY3CjdT__"